import React, {useRef, useState} from 'react';
import {Menu} from 'primereact/menu';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import CreateDatasetDialog from './create-dataset-dialog/CreateDatasetDialog';
import ClearDatasetDialog from './clear-dataset-dialog/ClearDatasetDialog';
import AddDataDialog from "./add-data-dialog/AddDataDialog";
import {ChronoUnitLegacy} from "utils/time-utils";


const DatasetsMenu = ({selectedDatasetID}) => {
    const [createDatasetDialogVisibility, setCreateDialogVisibility] = useState<boolean>(false)
    const [clearDataDialogVisibility, setClearDataDialogVisibility] = useState<boolean>(false)
    const [addDataDialogVisibility, setAddDataDialogVisibility] = useState<boolean>(false)

    const menu = useRef(null);
    const items = [
        {
            label: 'Dataset options',
            items: [
                {
                    label: 'Create dataset',
                    icon: 'pi pi-plus-circle',
                    command: () => {
                        setCreateDialogVisibility(true)
                    }
                }
            ]
        },
        {
            label: 'Data options',
            items: [
                {
                    label: 'Add data',
                    icon: 'pi pi-plus',
                    command: () => {
                        setAddDataDialogVisibility(true)
                    },
                    disabled: selectedDatasetID.length !== 1
                },
                {
                    label: 'Clear data',
                    icon: 'pi pi-info-circle',
                    command: () => {
                        setClearDataDialogVisibility(true)
                    },
                    disabled: selectedDatasetID.length !== 1
                }
            ]
        }

    ];

    return (
        <>
            <div>
                <Menu model={items} popup ref={menu} id="popup_menu"/>
                <Button className="p-button-outlined p-button-secondary" icon="pi pi-bars"
                        onClick={(event) => menu.current.toggle(event)} aria-controls="popup_menu" aria-haspopup/>
            </div>
            <Dialog
                style={{width: 'min(100vw, 800px)', height: '400x'}}
                header="Create new dataset"
                visible={createDatasetDialogVisibility}
                onHide={() => setCreateDialogVisibility(false)}
                resizable={true}
            >
                <CreateDatasetDialog setCreateDialogVisibility={setCreateDialogVisibility}/>
            </Dialog>
            <Dialog
                style={{width: 'min(100vw, 400px)', height: '400x'}}
                header="Clear dataset data"
                visible={clearDataDialogVisibility}
                onHide={() => setClearDataDialogVisibility(false)}
                resizable={false}
                modal
            >
                <ClearDatasetDialog setClearDataDialogVisibility={setClearDataDialogVisibility}
                                    selectedDatasetID={selectedDatasetID}/>
            </Dialog>
            <Dialog onHide={() => setAddDataDialogVisibility(false)}
                    style={{ width: 'min(100vw, 600px)', height: '400x' }}
                    visible={addDataDialogVisibility}
                    header={'Add data to dataset'}
                    modal={true}
            >
                <AddDataDialog selectedDatasetID={selectedDatasetID}
                               firstLoadDate={new Date()}
                               dateFrequency={ChronoUnitLegacy.MINUTES}
                               closeDialog={() => setAddDataDialogVisibility(false)}
                />
            </Dialog>
        </>
    );
}

export default DatasetsMenu;